import axios from 'axios'

let _svc
let _that

export default {
  Init: (that) => {
    _that = that

    _svc = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  CheckPayment: (id) => {
    try {
      return _svc.get(`Payment/Check/${id}`)
    } catch {
      return null
    }
  },
  CreatePayment: (data) => {
    try {
      return _svc.post('Payment/Create', data)
    } catch {
      return null
    }
  }
}
